



















import {Component, Vue} from 'vue-property-decorator';
import CompaniesTable from '@/components/CompaniesTable.vue';
import {namespace} from "vuex-class";
import {CompanyFilters} from "@/interfaces/company.interface";

const companiesModule = namespace('companies');

@Component({
  components: {CompaniesTable}
})
export default class CompaniesView extends Vue {
  @companiesModule.Action fetchCompanies!: any;
  @companiesModule.Action setCompaniesFilter!: any;
  @companiesModule.State companyFilters!: CompanyFilters;

  searchTimer: number;

  get search(): string {
    return this.companyFilters.search || '';
  }

  set search(search: string) {
    this.setCompaniesFilter({search});
  }

  startSearchCountdown() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.fetchCompanies();
    }, 300);
  }

  mounted() {
    this.fetchCompanies();
  }
}
